'use strict'

export const DATE_TIME_FULL_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export function formatDayjs (dayjs) {
  return dayjs.format(DATE_TIME_FULL_FORMAT)
}
